/** JSON backup: same format as the original app's "Export backup", so existing backups import unchanged. */
import type { Backup } from '@/types/models';

export const isBackup = (d: unknown): d is Backup => {
  const b = d as Partial<Backup> | null;
  return !!b && Array.isArray(b.projects) && Array.isArray(b.members) && Array.isArray(b.logs) && Array.isArray(b.updates);
};

/** Fills fields older backups may lack (same defaults the original app applied on load). */
export function normalizeBackup(d: Backup): Backup {
  if (!isBackup(d)) throw new Error('That file is not a valid backup.');
  d.projects.forEach((p) => {
    p.extensions = p.extensions || [];
    p.metricKinds = p.metricKinds || {};
    p.metricKeys = p.metricKeys || [];
    p.links = p.links || [];
    p.members = p.members || [];
  });
  d.updates.forEach((u) => (u.metrics = u.metrics || []));
  d.settings = d.settings || { reportTitle: 'Daily Update - {date}', generalMembers: [] };
  d.settings.generalMembers = d.settings.generalMembers || [];
  return d;
}
